import React, { useRef } from "react";
import styles from './SectionColumns.module.css';
import SVG_OBJECT from "./SvgObject";
import { LayoutComposer } from "../../PageBuilder";
import TopbarContainer from "../../../TopbarContainer/TopbarContainer";
import FooterContainer from "../../../FooterContainer/FooterContainer";
import ServicesCard from "./ServicesCard/ServicesCard";
import imageOne from "./photo-1668097613572-40b7c11c8727.jpg";
import avtarImage from './photo-1425421669292-0c3da3b8f529.jpg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
const ServicesData = [
    {
        image: imageOne,
        title: "Residential Solar Panel Installation & Setup",
        provider: "Marcus Green",
        rating: 4.9,
        reviews: 127,
        time: "5-7 days",
        location: "Phoenix, AZ",
        tags: ["Solar Panels", "Installation", "ROI Analysis"],
        price: 8500,
        priceUnit: "/system",
        providerIcon: SVG_OBJECT['Solar Energy'],
        avatar: avtarImage,
        onDetails: () => alert('View Details Clicked!')
    },
    {
        image: imageOne,
        title: "Residential Solar Panel Installation & Setup",
        provider: "Marcus Green",
        rating: 4.9,
        reviews: 127,
        time: "5-7 days",
        location: "Phoenix, AZ",
        tags: ["Solar Panels", "Installation", "ROI Analysis"],
        price: 8500,
        priceUnit: "/system",
        avatar: avtarImage,
        providerIcon: SVG_OBJECT['Wind Energy'],
        onDetails: () => alert('View Details Clicked!')
    },
    {
        image: imageOne,
        title: "Residential Solar Panel Installation & Setup",
        provider: "Marcus Green",
        rating: 4.9,
        reviews: 127,
        time: "5-7 days",
        location: "Phoenix, AZ",
        tags: ["Solar Panels", "Installation", "ROI Analysis"],
        price: 8500,
        priceUnit: "/system",
        avatar: avtarImage,
        providerIcon: SVG_OBJECT['Energy Efficiency'],
        onDetails: () => alert('View Details Clicked!')
    },
    {
        image: imageOne,
        title: "Residential Solar Panel Installation & Setup",
        provider: "Marcus Green",
        rating: 4.9,
        reviews: 127,
        time: "5-7 days",
        location: "Phoenix, AZ",
        tags: ["Solar Panels", "Installation", "ROI Analysis"],
        price: 8500,
        priceUnit: "/system",
        avatar: avtarImage,
        providerIcon: SVG_OBJECT['Energy Efficiency'],
        onDetails: () => alert('View Details Clicked!')
    }
]

const NewSectopmFeaturs = () => {
    const layoutAreas = `
    topbar
    main
    footer
  `;

    // Refs for first swiper navigation buttons
    const firstSwiperPrevRef = useRef(null);
    const firstSwiperNextRef = useRef(null);

    // Refs for second swiper navigation buttons
    const secondSwiperPrevRef = useRef(null);
    const secondSwiperNextRef = useRef(null);

    return (
        <LayoutComposer areas={layoutAreas} className={styles.layout}>
            {props => {
                const { Topbar, Main, Footer } = props;
                return (
                    <>
                        <Topbar as="header" className={styles.topbar}>
                            <TopbarContainer currentPage={"/"} />
                        </Topbar>
                        <Main as="main" className={styles.main}>
                            <div class={styles.topSearchSection}>
                                <div class={styles.searchTitels}>
                                    <h1 className="MuiTypography-root MuiTypography-h1 TRTypography-Root mui-bccdbr">Find Trusted Environmental Pros Fast</h1>
                                    <p>Your trusted hub to find a professional for environmental safety, testing, remediation, and restoration services.</p>
                                </div>
                            </div>
                            <div className={styles.pageWrapper}>
                                {/* Top Nav */}
                                <div className={styles.assemblyContainer}>
                                    <div className={styles.navIcons}>
                                        {[
                                            "Solar Energy",
                                            "Wind Energy",
                                            "Energy Efficiency",
                                            "Waste Management",
                                            "Green Building",
                                            "Environmental Consulting",

                                        ].map((item, idx) => (
                                            <button key={idx} className={`${styles.navItem} ${item === "Assembly" && styles.active}`}>
                                                <div className={styles.svgDiv}>
                                                    {SVG_OBJECT?.[item]}
                                                </div>
                                                <label>{item}</label>
                                                {(item === "Assembly") &&
                                                    <hr class={styles.smallLine} color="#066599"></hr>
                                                }

                                            </button>
                                        ))}
                                    </div>
                                    <hr class={styles.divider}></hr>
                                    {/* Category Buttons */}
                                    {/* <div className={styles.categoryWrapper}> */}
                                    {/* {[
                                            "General Furniture Assembly",
                                            "IKEA Assembly",
                                            "Crib Assembly",
                                            "PAX Assembly",
                                            "Bookshelf Assembly",
                                            "Desk Assembly",
                                        ].map((cat, idx) => (
                                            <div className={styles.categoryDiv}>
                                                <button key={idx} className={styles.categoryButton}>{cat}</button>
                                            </div>
                                        ))} */}
                                    {/* </div> */}

                                    {/* Hero Section */}
                                    {/* <div className={styles.heroSection}> */}
                                    {/* <div className={styles.textCard}>
                                            <h6>Assembly</h6>
                                            <ul>
                                                <li>
                                                    <svg aria-hidden="true" fill="currentColor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" className="mui-50pah1 TRIconBase-Root"><g id="Name=Check, Size=16"><path clip-rule="evenodd" d="M15 4.05155L5.97644 13.0751C5.68606 13.3655 5.21527 13.3655 4.92489 13.0751L1 9.15022L2.05155 8.09867L5.45066 11.4978L13.9485 3L15 4.05155Z" fill="currentColor" fill-rule="evenodd" id="Shape"></path></g></svg>
                                                    <p>Assemble or disassemble furniture items by unboxing, building, and any cleanup.</p>
                                                </li>
                                                <li>
                                                    <svg aria-hidden="true" fill="currentColor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" className="mui-50pah1 TRIconBase-Root"><g id="Name=Check, Size=16"><path clip-rule="evenodd" d="M15 4.05155L5.97644 13.0751C5.68606 13.3655 5.21527 13.3655 4.92489 13.0751L1 9.15022L2.05155 8.09867L5.45066 11.4978L13.9485 3L15 4.05155Z" fill="currentColor" fill-rule="evenodd" id="Shape"></path></g></svg>
                                                    <p>Now Trending: Curved sofas, computer desks, and sustainable materials.</p>
                                                </li>
                                            </ul>
                                        </div> */}
                                    <div className={styles.mainHeroImage}>
                                        <img className={styles.heroImage} alt="Image of a Tasker assembling furniture" decoding="async" data-nimg="fill" srcset="https://images.ctfassets.net/vwt5n1ljn95x/2zLfFEV2MrXbcska0MocE7/32575342bd9f30397d58ccb663c71744/Homepage_Assembly.png?w=640&amp;q=75&amp;fm=webp 640w, https://images.ctfassets.net/vwt5n1ljn95x/2zLfFEV2MrXbcska0MocE7/32575342bd9f30397d58ccb663c71744/Homepage_Assembly.png?w=750&amp;q=75&amp;fm=webp 750w, https://images.ctfassets.net/vwt5n1ljn95x/2zLfFEV2MrXbcska0MocE7/32575342bd9f30397d58ccb663c71744/Homepage_Assembly.png?w=828&amp;q=75&amp;fm=webp 828w, https://images.ctfassets.net/vwt5n1ljn95x/2zLfFEV2MrXbcska0MocE7/32575342bd9f30397d58ccb663c71744/Homepage_Assembly.png?w=1080&amp;q=75&amp;fm=webp 1080w, https://images.ctfassets.net/vwt5n1ljn95x/2zLfFEV2MrXbcska0MocE7/32575342bd9f30397d58ccb663c71744/Homepage_Assembly.png?w=1200&amp;q=75&amp;fm=webp 1200w, https://images.ctfassets.net/vwt5n1ljn95x/2zLfFEV2MrXbcska0MocE7/32575342bd9f30397d58ccb663c71744/Homepage_Assembly.png?w=1920&amp;q=75&amp;fm=webp 1920w, https://images.ctfassets.net/vwt5n1ljn95x/2zLfFEV2MrXbcska0MocE7/32575342bd9f30397d58ccb663c71744/Homepage_Assembly.png?w=2048&amp;q=75&amp;fm=webp 2048w, https://images.ctfassets.net/vwt5n1ljn95x/2zLfFEV2MrXbcska0MocE7/32575342bd9f30397d58ccb663c71744/Homepage_Assembly.png?w=3840&amp;q=75&amp;fm=webp 3840w" src="https://images.ctfassets.net/vwt5n1ljn95x/2zLfFEV2MrXbcska0MocE7/32575342bd9f30397d58ccb663c71744/Homepage_Assembly.png?w=3840&amp;q=75&amp;fm=webp"></img>
                                        {/* <img
                    src="/assembly-worker.jpg"
                    alt="Worker assembling furniture"
                    className={styles.heroImage}
                /> */}
                                    </div>
                                    {/* </div> */}
                                </div>

                                {/* {Popular Services} */}
                                <section className={styles.servicesSection}>
                                    <div className={styles.innerCardsBlock}>
                                        <h3>Popular services</h3>
                                        <Swiper
                                            className={styles.servicesSwiper}
                                            modules={[Navigation]}
                                            spaceBetween={20}
                                            slidesPerView={1}
                                            loop={true}
                                            navigation={{
                                                nextEl: firstSwiperNextRef.current,
                                                prevEl: firstSwiperPrevRef.current,
                                            }}
                                            onBeforeInit={(swiper) => {
                                                swiper.params.navigation.prevEl = firstSwiperPrevRef.current;
                                                swiper.params.navigation.nextEl = firstSwiperNextRef.current;
                                            }}
                                            //    navigation={{
                                            //             nextEl: '.customNext',
                                            //             prevEl: '.customPrev',
                                            //             }}
                                            breakpoints={{
                                                // when window width is >= 640px (tablet)
                                                640: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 24,
                                                },
                                                // when window width is >= 1024px (desktop)
                                                1024: {
                                                    slidesPerView: 3,
                                                    spaceBetween: 32,
                                                },
                                                // when window width is >= 1600px (large desktop)
                                                1600: {
                                                    slidesPerView: 3,
                                                    spaceBetween: 40,
                                                }
                                            }}
                                        >
                                            {ServicesData.map((item, index) => (
                                                <SwiperSlide className={styles.innerBlockSlider}>
                                                    <ServicesCard
                                                        key={index}
                                                        image={item.image}
                                                        providerIcon={item.providerIcon}
                                                        title={item.title}
                                                        provider={item.provider}
                                                        rating={item.rating}
                                                        reviews={item.reviews}
                                                        time={item.time}
                                                        location={item.location}
                                                        tags={item.tags}
                                                        price={item.price}
                                                        priceUnit={item.priceUnit}
                                                        avatar={item.avatar}
                                                        onDetails={item.onDetails}
                                                    />

                                                </SwiperSlide>
                                            ))}

                                        </Swiper>
                                        <button ref={firstSwiperPrevRef} className={styles.customPrev}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-left"><path d="m12 19-7-7 7-7"></path><path d="M19 12H5"></path></svg></button>
                                        <button ref={firstSwiperNextRef} className={styles.customNext}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-right"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></button>
                                        {/* <button className={styles.customPrev}>Prev</button>
                                            <button className="customnext">Next</button> */}
                                    </div>
                                </section>

                                {/* {Browse Pros near you}        */}
                                <section className={styles.servicesSection}>
                                    <div className={styles.innerCardsBlock}>
                                        <h3>Browse Pros near you</h3>
                                        <Swiper
                                            className={styles.servicesSwiper}
                                            modules={[Navigation]}
                                            spaceBetween={20}
                                            slidesPerView={1}
                                            loop={true}
                                            navigation={{
                                                nextEl: secondSwiperNextRef.current,
                                                prevEl: secondSwiperPrevRef.current,
                                            }}
                                            onBeforeInit={(swiper) => {
                                                swiper.params.navigation.prevEl = secondSwiperPrevRef.current;
                                                swiper.params.navigation.nextEl = secondSwiperNextRef.current;
                                            }}
                                            //    navigation={{
                                            //             nextEl: '.customNext',
                                            //             prevEl: '.customPrev',
                                            //             }}
                                            breakpoints={{
                                                // when window width is >= 640px (tablet)
                                                640: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 24,
                                                },
                                                // when window width is >= 1024px (desktop)
                                                1024: {
                                                    slidesPerView: 3,
                                                    spaceBetween: 32,
                                                },
                                                // when window width is >= 1600px (large desktop)
                                                1600: {
                                                    slidesPerView: 3,
                                                    spaceBetween: 40,
                                                }
                                            }}
                                        >
                                            {ServicesData.map((item, index) => (
                                                <SwiperSlide className={styles.innerBlockSlider}>
                                                    <ServicesCard
                                                        key={index}
                                                        image={item.image}
                                                        providerIcon={item.providerIcon}
                                                        title={item.title}
                                                        provider={item.provider}
                                                        rating={item.rating}
                                                        reviews={item.reviews}
                                                        time={item.time}
                                                        location={item.location}
                                                        tags={item.tags}
                                                        price={item.price}
                                                        priceUnit={item.priceUnit}
                                                        avatar={item.avatar}
                                                        onDetails={item.onDetails}
                                                    />

                                                </SwiperSlide>
                                            ))}

                                        </Swiper>
                                        <button ref={secondSwiperPrevRef} className={styles.customPrevSecond}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-left"><path d="m12 19-7-7 7-7"></path><path d="M19 12H5"></path></svg></button>
                                        <button ref={secondSwiperNextRef} className={styles.customNextSecond}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-right"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></button>
                                        {/* <button className={styles.customPrev}>Prev</button>
                                            <button className="customnext">Next</button> */}
                                    </div>
                                </section>

                                {/* Stats Section */}
                                {/* <div className={styles.mainStats}> */}
                                {/* <div className={styles.statsSection}>
                                        <div className={styles.counts}>
                                            {[
                                                { label: "Furniture Assemblies", value: "3.4 million+" },
                                                { label: "Moving tasks", value: "1.5 million+" },
                                                { label: "Items mounted", value: "1 million+" },
                                                { label: "Home Repairs", value: "700,000+" },
                                                { label: "Homes cleaned", value: "890,000+" },
                                            ].map((stat, idx) => (
                                                <div key={idx} className={styles.statItem}>
                                                    <h6 className={styles.statLabel}>{stat.label}:</h6>
                                                    <h6 className={styles.statValue}>{stat.value}</h6>
                                                </div>
                                            ))}
                                            <div className={styles.ikeaBox}>
                                                <img src="https://images.ctfassets.net/vwt5n1ljn95x/4DcDpxTyJZ2mQQi40pp4oQ/c5975f4d354af29127d0ed0265a448ea/Size_Default__Background_White__Language_en-US-CA__Logo_IKEA.png?w=3840&amp;q=75&amp;fm=webp" alt="IKEA" className={styles.ikeaLogo} />
                                            </div>
                                        </div>
                                    </div> */}
                                {/* </div> */}

                                <div className={styles.popularProjectSection}>
                                    <h2 className={styles.popularHeading}> Popular Projects</h2>
                                    <ul className={styles.popularList}>
                                        {[
                                            { name: "Furniture Assembly", desc: "Projects starting at $49", img: "https://images.ctfassets.net/vwt5n1ljn95x/15JB3WRwRtvEsf5rcVKmnK/610c440541b1cca93bee3534037379e7/Furniture_Assembly.jpeg?w=3840&q=75&fm=webp" },
                                            { name: "Mount Art or Shelves", desc: "Projects starting at $65", img: "https://images.ctfassets.net/vwt5n1ljn95x/3sbIHOfdhBhVilGyaApius/829a05b423c4aff40b3bb007668e85cb/Hang_Pictures.jpeg?w=3840&q=75&fm=webp" },
                                            { name: "Mount a TV", desc: "Projects starting at $69", img: "https://images.ctfassets.net/vwt5n1ljn95x/3yZJxfcMurN3fYgm2VIw3v/1f0aee924e621fd5e2684f01f92ca7b2/Mount_TV.jpg?w=3840&q=75&fm=webp" },
                                            { name: "Help Moving", desc: "Projects starting at $67", img: "https://images.ctfassets.net/vwt5n1ljn95x/5RdOpgNLV7GFgjHegMSn4S/4da60b993bc3b03fcef4d19645c38e59/Help_Moving.jpg?w=3840&q=75&fm=webp" },
                                            { name: "Home & Apartment Cleaning", desc: "Projects starting at $49", img: "https://images.ctfassets.net/vwt5n1ljn95x/51s0CVltl03F7bOfy31VXB/8a5adaf0c64e789c7f202329724806c0/Home_Apartment_Cleaning.jpg?w=3840&q=75&fm=webp" },
                                            { name: "Minor Plumbing Repairs", desc: "Projects starting at $74", img: "https://images.ctfassets.net/vwt5n1ljn95x/2vw8Ct7BWBT12032WBzVyf/5332c4b1fc0b678d442c64307f31c2ae/AdobeStock_197426992.jpeg?w=3840&q=75&fm=webp" },
                                            { name: "Electrical Help", desc: "Projects starting at $69", img: "https://images.ctfassets.net/vwt5n1ljn95x/BUqnE9Sgc6YHLGISWe04H/31c63bdb1bc70d72161e4327594c6629/Electrical_Help.jpg?w=3840&q=75&fm=webp" },
                                            { name: "Heavy Lifting", desc: "Projects starting at $61", img: "https://images.ctfassets.net/vwt5n1ljn95x/7KPnZ2S2uRjZlNplopaKJP/e317265a0877d21660d36cc222e13af9/Furniture_Removal__1_.jpg?w=3840&q=75&fm=webp" }
                                        ]?.map((r) => (
                                            <li className={styles.list} key={r?.name}>
                                                <a href="">
                                                    <div className={styles.listData}>
                                                        <div className={styles.listImage}>
                                                            <img src={r?.img} />
                                                        </div>
                                                        <div className={styles.listDetail}>
                                                            <p className={styles.popularName}>{r?.name}</p>
                                                            <p className={styles.popularDesc}>{r?.desc}</p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                        ))}

                                    </ul>
                                </div>

                                <div className={styles.review_container}>
                                    <div className={styles.review_main}>
                                        <h2 className={styles.review_header}>See what happy customers are saying about Taskrabbit</h2>
                                        <ul className={styles.review_lists}>
                                            {[
                                                { reviewerName: "Elizabeth P.", message: "Vitalii assembled the IKEA Norli drawer chest for me in less than 30 minutes, and he assembled a metal wire shelving unit as well in about 10 minutes. He also fixed a drawer on an already assembled desk so it", productName: "IKEA Furniture Assembly", productLink: "#", rating: 4 },
                                                { reviewerName: "Tiffany B.", message: "David did an awesome job assembling crib and dresser for nursery. Really appreciate this! He cleaned up the area after his work, organized the boxes for easy disposal and went through the", productName: "Furniture Assembly", productLink: "#", rating: 5 },
                                                { reviewerName: "Amanda L.", message: "I hired Joe to patch 2 holes on my wall and 1 hole on my ceiling. Joe was great with communication, was fast, professional and did a fantastic job. He even came back to do a second layer on the patches to make", productName: "Home repairs", productLink: "#", rating: 5 },
                                                { reviewerName: "Sabrina K.", message: "Aleksandr was fantastic! He came with all the equipment to do the job, even the hardware I didn't know I would need. He hung a heavy chandelier perfectly and fixed a cabinet to our wall. 100% would hir", productName: "Electrical help", productLink: "#", rating: 4 },
                                                { reviewerName: "Jana T.", message: "Jose fixed my AC drain line which was clogging my master bathroom sink. He was prompt, communicative, and efficient. Highly recommend!", productName: "Plumbing", productLink: "#", rating: 5 },
                                                { reviewerName: "Elisa R.", message: "Michael did a great job helping us install frameless glass hinged shower doors with an unusual set up. He was patient and willing to help figure it out with us. Thank you Michael!", productName: "General Mounting", productLink: "#", rating: 5 },
                                            ]?.map((r) => (
                                                <li className={styles.review} key={r?.reviewerName}>
                                                    <span className={styles.reviewerName}>{r?.reviewerName}</span>
                                                    <span className={styles.startRating}>
                                                        {Array.from({ length: r?.rating })?.map((_, idx) => (
                                                            <svg key={idx + '_' + new Date().getTime()} aria-hidden="true" data-testid="star" fill="currentColor" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" className="TRStarRating-icon icon-star mui-0 TRIconBase-Root">
                                                                <g id="Name=Star, Style=filled, Size=24">
                                                                    <g id="Shape">
                                                                        <path clip-rule="evenodd" d="M11.8751 1C12.2558 1 12.5929 1.24623 12.7086 1.60897L14.9965 8.77778H21.8751C22.25 8.77778 22.5833 9.01672 22.7037 9.37186C22.8241 9.727 22.7048 10.1194 22.4071 10.3474L16.9152 14.5544L19.2061 21.6046C19.3233 21.9651 19.1949 22.36 18.8883 22.5829C18.5816 22.8057 18.1664 22.8057 17.8597 22.5829L11.8751 18.2354L5.89043 22.5829C5.58375 22.8057 5.16849 22.8057 4.86182 22.5829C4.55516 22.36 4.42685 21.9651 4.544 21.6046L6.83494 14.5544L1.34296 10.3474C1.04527 10.1194 0.925984 9.727 1.04637 9.37186C1.16676 9.01672 1.50006 8.77778 1.87505 8.77778H8.7536L11.0415 1.60897C11.1572 1.24623 11.4943 1 11.8751 1ZM11.8751 4.75296L10.2264 9.91881C10.1106 10.2815 9.77359 10.5278 9.39283 10.5278H4.45622L8.39048 13.5415C8.68494 13.767 8.80519 14.1538 8.69056 14.5065L7.04051 19.5844L11.3608 16.446C11.6674 16.2232 12.0827 16.2232 12.3893 16.446L16.7096 19.5844L15.0596 14.5065C14.9449 14.1538 15.0652 13.767 15.3596 13.5415L19.2939 10.5278H14.3573C13.9765 10.5278 13.6395 10.2815 13.5237 9.91881L11.8751 4.75296Z" fill="currentColor" fill-rule="evenodd">
                                                                        </path>
                                                                        <path d="M11.9999 4L14.0206 10.2188H20.5594L15.2694 14.0623L17.29 20.2812L11.9999 16.4377L6.70987 20.2812L8.7305 14.0623L3.44043 10.2188H9.97931L11.9999 4Z" fill="currentColor"></path>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        ))}

                                                    </span>
                                                    <span className={styles.reviewMessage}>
                                                        {r?.message}
                                                    </span>
                                                    <a className={styles.productLink} href={r?.productLink}>
                                                        {r?.productName}
                                                    </a>
                                                </li>
                                            ))}

                                        </ul>
                                    </div>
                                </div>


                                <div class={styles.satisFectionSection}>
                                    <div class={styles.statisfectionMain}>
                                        <h1 class={styles.statisTitle}>
                                            Your satisfaction,<span class="MuiTypography-root MuiTypography-h1 TRTypography-Root mui-15kdggz">&nbsp;guaranteed</span>
                                        </h1>
                                        <div class={styles.satisFectionContent}>
                                            <div class={styles.content}>
                                                <h3 class={styles.contentTitle}>Happiness Pledge</h3>
                                                <div class={styles.contentDesc}>
                                                    <p>
                                                        If you’re not satisfied, <a href="https://www.taskrabbit.com/blog/taskrabbit-happiness-pledge" rel="noopener noreferrer" target="_blank"><u>we’ll work to make it right.</u></a>
                                                    </p>
                                                </div>
                                                <div class={styles.happpinessIcon}>
                                                    <a href="https://www.taskrabbit.com/blog/taskrabbit-happiness-pledge">
                                                        <img alt="Taskrabbit's happiness" src="https://images.ctfassets.net/vwt5n1ljn95x/9iQ98KhxJ7uYRwguxiVBh/861425b05239b1eb27754ffdba8426ea/English_2x.png?w=3840&amp;q=75&amp;fm=webp" />
                                                    </a>
                                                </div>
                                            </div>
                                            <div class={styles.content}>
                                                <h3 class={styles.contentTitle}>Vetted Taskers</h3>
                                                <div class={styles.contentDesc}>
                                                    <p>
                                                        Taskers are always background checked before joining the platform.
                                                    </p>
                                                </div>
                                            </div>
                                            <div class={styles.content}>
                                                <h3 class={styles.contentTitle}>Dedicated Support</h3>
                                                <div class={styles.contentDesc}>
                                                    <p>Friendly service when you need us – every day of the week.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* How it Works Section */}
                                <div className={styles.howWrapper}>
                                    <div className={styles.howCard}>
                                        <div className={styles.howRootSection}>
                                            <div className={styles.WomanPicture}>
                                                <img
                                                    src="https://images.ctfassets.net/vwt5n1ljn95x/68OY5vAHQdG6blVvXM1WT7/5f45c9eda06d29820a9836a11232ef16/how_it_works_pic_updated.jpg?w=3840&q=75&fm=webp"
                                                    alt="User checking phone in kitchen"
                                                    className={styles.howImage}
                                                />
                                            </div>
                                            <div className={styles.howContent}>
                                                <h2>How it works</h2>
                                                <div className={styles.howStep}>
                                                    <div className={`${styles.stepCircle} ${styles.step1}`}>
                                                        <h3>1</h3>
                                                    </div>
                                                    <p>Choose a Tasker by price, skills, and reviews.</p>
                                                </div>
                                                <div className={styles.howStep}>
                                                    <div className={`${styles.stepCircle} ${styles.step2}`}><h3>2</h3></div>
                                                    <p>Schedule a Tasker as early as today.</p>
                                                </div>
                                                <div className={styles.howStep}>
                                                    <div className={`${styles.stepCircle} ${styles.step3}`}><h3>3</h3></div>
                                                    <p>Chat, pay, tip, and review all in one place.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className={styles.getHelpToday}>
                                    <h2>Get help Today</h2>
                                    <div className={styles.categoryWrapper} style={{ marginBottom: '48px' }}>
                                        {[
                                            "General Mounting",
                                            "TV Mounting",
                                            "Furniture Assembly",
                                            "IKEA Furniture Assembly",
                                            "Help moving",
                                            "House Cleaning",
                                            "Yardwork",
                                            "Furniture Removal",
                                            "Lawn Care",
                                            "Hang Pictures",
                                            "In Home Furniture Movers",
                                            "Shelf Mounting",
                                            "Light Installation",
                                            "Plumbing"
                                        ].map((cat, idx) => (
                                            <div className={styles.categoryDiv}>
                                                <button key={idx} className={styles.categoryButton}>{cat}</button>
                                            </div>
                                        ))}
                                    </div>
                                    <div class={styles.serviceLink}>
                                        <a href="#" target="_blank" class="mui-v8f8s6">See All Services</a>
                                        <svg aria-hidden="true" fill="currentColor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" class="mui-1isemmb TRIconBase-Root">
                                            <g id="Name=Chevron, Direction=right, Size=16">
                                                <path clip-rule="evenodd" d="M4 13.9155L9.91554 8L4 2.08446L5.08446 1L11.5422 7.45777C11.8417 7.75724 11.8417 8.24277 11.5422 8.54223L5.08446 15L4 13.9155Z" fill="currentColor" fill-rule="evenodd" id="Shape"></path>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </div >
                        </Main>
                        <Footer>
                            <FooterContainer />
                        </Footer>
                    </>
                );
            }}
        </LayoutComposer>

    );
};

export default NewSectopmFeaturs;
